import { render, staticRenderFns } from "./StornoDialog.vue?vue&type=template&id=054be120&"
import script from "./StornoDialog.vue?vue&type=script&lang=js&"
export * from "./StornoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports